import { createApp } from 'vue'

import 'vue-fullpage.js/dist/style.css'
import VueFullPage from 'vue-fullpage.js'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'


import 'vue-loading-overlay/dist/vue-loading.css';


import App from './App.vue'


import Vuex from 'vuex'

import lazyPlugin from 'vue3-lazy'



const app = createApp(App)



const store = new Vuex.Store({
  state: {
    count: 0,
    isShowModal:false,
    download:'',
    isLoading:false,
    isTopShow:false,
    soundOn:false,
    isShowModal_declare:true,
    lang:'cn',
    videoSource : require('@/assets/video/Cantonese.mp4')
  },
  mutations: {
    increment (state) {
      state.count++
    }
    
  }
})

app.use(Vuex)
app.use(VueFullPage)

app.use(VueViewer)
app.use(store)


app.use(lazyPlugin, {
    loading: require('@/assets/img/loading.gif'), // 图片加载时默认图片
   // error: require('../assets/images/error.png')// 图片加载失败时默认图片
  }) 



app.mount('#app')


